(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hh-countdown"] && !Shopify.designMode) return;
  try {
    // Hortus Home: Countdown bis zum festen Aktionsende
  if (!customElements.get('hh-countdown')) {
    customElements.define('hh-countdown', class extends HTMLElement {
      connectedCallback() {
        this.end = parseInt(this.dataset.end, 10) * 1000;
        this.out = this.querySelector('[data-hh-cd]');
        if (!this.end || !this.out) return;
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      tick() {
        const ms = this.end - Date.now();
        if (ms <= 0) { clearInterval(this.timer); this.hidden = true; return; }
        const s = Math.floor(ms / 1000);
        const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
        const p = (n) => String(n).padStart(2, '0');
        this.out.textContent = (d > 0 ? `${d} T. ` : '') + `${p(h)}:${p(m)}:${p(sec)}`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hh-delivery"] && !Shopify.designMode) return;
  try {
    // Hortus Home: Lieferdatum berechnen (nur Werktage, keine Feiertage)
  if (!customElements.get('hh-delivery')) {
    customElements.define('hh-delivery', class extends HTMLElement {
      connectedCallback() {
        const min = parseInt(this.dataset.min, 10);
        const max = parseInt(this.dataset.max, 10);
        const target = this.querySelector('[data-hh-delivery-text]');
        if (!target || isNaN(min) || isNaN(max)) return;
        const addBusinessDays = (days) => {
          const d = new Date();
          let added = 0;
          while (added < days) {
            d.setDate(d.getDate() + 1);
            const wd = d.getDay();
            if (wd !== 0 && wd !== 6) added++;
          }
          return d;
        };
        const fmt = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'short' });
        target.innerHTML = `Lieferung voraussichtlich <strong>${fmt.format(addBusinessDays(min))} – ${fmt.format(addBusinessDays(max))}</strong>`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hh-value-stack"] && !Shopify.designMode) return;
  try {
    // Hortus Home: Gesamtwert = Produktpreis + Werte der Positionen
  if (!customElements.get('hh-value-stack')) {
    customElements.define('hh-value-stack', class extends HTMLElement {
      connectedCallback() {
        const price = parseInt(this.dataset.price || '0', 10);
        const extra = [...this.querySelectorAll('[data-hh-value]')].reduce((sum, el) => sum + (parseInt(el.dataset.hhValue, 10) || 0), 0);
        const out = this.querySelector('[data-hh-worth]');
        if (!out || extra <= 0 || price <= 0) return;
        const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
        out.querySelector('[data-hh-worth-sum]').textContent =
          new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: cur }).format((price + extra) / 100);
        out.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
